<form [formGroup]="form">
  <h3-attribute-display-label
    [attribute]="attribute"
    [annotationStore]="annotationStore"
    [attributeValue]="attributeValue$ | async"
  >
    <mat-slide-toggle
      [disabled]="isReadOnly$ | async"
      [checked]="(attributeValue$ | async) === options.true.value"
      (change)="toggleInput($event)"
    ></mat-slide-toggle>
  </h3-attribute-display-label>
</form>
